import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import withModal from '../WithModal';
import { storage } from '../../../config';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';

import fileIcon from './file.png';
import './DownloadPropertyAreaFilesModal.css';

export class SpecialAttachmentsDownloadPropertyAreasModalComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentImageIndex: 0,
    };
  }

  render() {
    const { onModalClick, files, modalHeader } = this.props;
    const header = modalHeader || 'Downloads';
    return (
      <div className="modal-wrapper download-property-area-files-modal">
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <div className="modal-header">
            <h2 className="modal-title">{header}</h2>
            <a tabIndex="0" onClick={onModalClick}>
              <div className="modal-close">
                {svgInline(closeIcon)}
              </div>
            </a>
          </div>
        </ViewerPrimaryColorUserStyle>
        <div className="modal-body">
          <ul>
            {
              files.sort((a, b) => a.sequence - b.sequence).map(file => {
                let hrefResult = `${storage.cloudStoragePath}/${file.filename}`;
                if (file.filename.indexOf('http') === 0) {
                  hrefResult = `${file.filename}`;
                }
                return (
                  <li key={file.filename} className="download-modal-download">
                    <img src={fileIcon} role="presentation" className="download-modal-image" />
                    <a href={hrefResult} target="_blank" rel="noopener noreferrer" download>{file.description_tx}</a>
                  </li>
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

SpecialAttachmentsDownloadPropertyAreasModalComponent.propTypes = {
  onModalClick: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(PropTypes.shape({
    sequence: PropTypes.number,
    filename: PropTypes.string,
    description_tx: PropTypes.string,
    imageUrl: PropTypes.string,
    link: PropTypes.string,
  })),
  modalHeader: PropTypes.string,
};


export default withModal(SpecialAttachmentsDownloadPropertyAreasModalComponent, 'specialDownloadPropertyAreas');



// WEBPACK FOOTER //
// ./src/components/Modal/DownloadPropertyAreaFilesModal/SpecialAttachmentsDownloadPropertyAreasModal.js